import { ArrowInSquareIcon } from "../../../images";
import { EllipsisTooltip } from "../../CustomTooltip";
import { useState } from "react";
import { useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";
import { useGetCampaignDetailsQuery } from "../../../../api";
import { useParams } from "react-router-dom";
import { ExportPlaybooksCsvModal } from "../../modal/ExportPlaybooksCSVModal";
import { ReuseButton } from "../../ReuseButton";

export const ExportPlaybooksBtn = () => {
  const { account_id } = useParams();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedExportPlaybooks } = useAppSelector(selectPermissions);

  const { data } = useGetCampaignDetailsQuery(
    { account_id: account_id! },
    { skip: !account_id },
  );

  return (
    <>
      <EllipsisTooltip
        tooltip={
          data?.total_members_with_playbook === 0
            ? "You haven’t playbooks yet"
            : "Export to CSV"
        }
      >
        <ReuseButton
          onClick={() => setIsOpen(true)}
          disabled={
            data?.total_members_with_playbook === 0 || !isAllowedExportPlaybooks
          }
          sx={{ paddingX: "6px", minWidth: 0 }}
        >
          <ArrowInSquareIcon
            color={isAllowedExportPlaybooks ? "#1D3E70" : "#A5B2C6"}
          />
        </ReuseButton>
      </EllipsisTooltip>

      {isOpen && (
        <ExportPlaybooksCsvModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          account_id={account_id!}
        />
      )}
    </>
  );
};
